var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgWallet(props) {
  return React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.28 1.204L3.041 5H3c-.772 0-1.475.291-2.007.77-.616.465-.985 1.177-.977 1.918C.006 7.791 0 7.895 0 8v12a3 3 0 003 3h18a3 3 0 003-3V8a3 3 0 00-3-3h-1.03l-.644-2.242c-.355-1.239-1.719-1.935-3.046-1.554zM10.297 5h7.592l-.38-1.325c-.109-.379-.541-.588-.966-.466L10.297 5zM2 8a1 1 0 011-1h18a1 1 0 011 1v2H2V8zm0 4v8a1 1 0 001 1h18a1 1 0 001-1v-8H9v.1a1 1 0 01-1 1H6a1 1 0 01-1-1V12H2z",
    fill: "#000"
  }));
}

export default SvgWallet;